<template>
    <v-btn icon elevation="0" size="default" @click="$emit('buttonClicked')">
        <img 
            :src="require('@/assets/' + buttonType + '.png')"
            width="26"
            height="26"
        />
    </v-btn>
</template>
<script>
    export default {
        name: 'ViewerPadButton',
        props: {
            buttonType: String 
        }
    }
</script>
